<template>
  <div :class="['result-role-wrapper', `${page_style}`]">
    <!-- 调试暂时加上h5_funnel_fleet_pc, 记得删掉 -->
    <div id="result-role" :class="['result-role', `${page_style}`]">
      <img-v3 v-if="resultConfig.icon" :class="['result-icon', {'big-result-icon': resultConfig.icon_size === 'big'}]" :src="resultConfig.icon" />
      <div :class="['content-wrap', {'content-wrap-center': resultConfig.align === 'center'}]">
        <h1 class="content-title">{{config_content.title}}</h1>
        <!-- config_content.desc -->
        <p class="content-desc" v-for="(t, idx) in config_content.desc" :key="idx" v-html="t"></p>
      </div>
      <div class="footer-wrap" v-if="config_footer.length && showFooter">
        <div :class="['footer-btn-wraper', `${itemShowClass(item)}`]" v-for="(item, idx) in config_footer" :key="idx">
          <component :is="getCom(item)" :btn-item="item" :omega-item="omegaItem"></component>
        </div>
      </div>
      <div v-if="img_link" class="img-link">
        <img-link
            :form-item="img_link"
            :omega-item="omegaItem"
        ></img-link>
      </div>
      <div v-if="rotation_banner" class="rotation-banner">
        <home-banner
            :form-item="rotation_banner"
            :page_style="page_style"
            :position_style="'inside_rotation_banner'"
            :omega-item="omegaItem"
        ></home-banner>
      </div>
    </div>
  </div>

</template>

<script>
import { mapState, mapMutations } from "vuex";
import { post } from "../tools/request";
import { getEnd, computeJumpTime, computeStayTime } from "../tools/utils";
import { showAlertDialog, showLoadingToast } from "../tools/Tip";
import { setTitle } from "../tools/setTitle";
import RoleTransitionBtn from "./base/role-transition-btn";
import DownloadBtn from "./base/download-btn";
import ImgLink from "./base/img-link.vue";
import HomeBanner from "../components/loginComp/home-banner.vue";

export default {
  name: "resultRoleInfo",
  components: { RoleTransitionBtn, DownloadBtn, ImgLink, HomeBanner}, // Lottie
  data() {
    return {
      timeId: null, // 轮询使用
      resultConfig: {},
    };
  },
  computed: {
    ...mapState([
      "_ticket",
      "_uuid",
      "_page_stay_time",
      "_page_jump_time",
      "_route_path"
      ]),
    isPreviewPage() {
      let up = new URLSearchParams(location.search);
      return up.get('ob_page_type') === 'preview';
    },
    config_content() {
      return this.resultConfig.content || {};
    },
    config_footer() {
      return this.resultConfig.footer || [];
    },
    showFooter() {
      let end = getEnd();
      let showFooter = false;
      this.config_footer.forEach(item => {
        let d = item.display;
        if (!d || d.includes(end)) {
          showFooter = true;
        }
      });
      return showFooter
    },
    omegaItem() {
      let up = new URLSearchParams(window.location.search);
      return{
        country: up.get('location_country'),
        o_id: up.get("oid") || Omega.getOmgid(),
        channel_id: up.get("channel"),
        end: getEnd(),
        driver_id: up.get("uid") || this._uuid + '',
        page_type: this.resultConfig.page_type
      }
    },
    img_link() {
      return this.resultConfig['img-link'] || null;
    },
    rotation_banner() {
      return this.resultConfig['rotation-banner'] || null;
    },
    page_style() {
      return this.resultConfig.page_style_funnel;
    },
    isFleetFunnel() {
      return this.page_style === "h5_funnel_fleet";
    },
  },
  methods: {
    ...mapMutations(["setState"]),
    itemShowClass(item) {
      let end = getEnd();
      let d = item.display;
      if (!d) {
        return '';
      }
      return d.includes(end) ? '' : 'no-show';
    },
    getCom(item) {
      return {
        "jump-button": RoleTransitionBtn,
        "download-button": DownloadBtn
      }[item.type];
    },
    getPageConfig() {
      showLoadingToast(this, this.$t("加载中"));
      let up = new URLSearchParams(window.location.search);
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      const reqUrl = this.isPreviewPage ? process.env.RESULT_URL_PRE : process.env.RESULT_URL
      post(reqUrl, up)
        .then(data => {
          this.resultConfig = data;
          this.driver_role = data.driver_role || 1;
          data.title && setTitle(data.title);

          // 结果页曝光
          try {
            Omega.trackEvent("ibt_register_review_result_page_en", "", this.omegaItem);
          } catch (e) {}

          if(up.get('fleet') === 'ru-fe') {
            window.parent.postMessage({type:"resultRoleInfo",message:"close", page_type: data.page_type},"https://fleet-ru.didiglobal.com")
            // window.parent.postMessage({type:"resultRoleInfo",message:"close", page_type: data.page_type}, "https://pre-fleet-us.intra.didiglobal.com")
          } else if(up.get('fleet') === 'us-fe') {
            window.parent.postMessage({type:"resultRoleInfo",message:"close", page_type: data.page_type},"https://fleet-us.didiglobal.com")
            window.parent.postMessage({type:"resultRoleInfo",message:"close", page_type: data.page_type},"https://fleet-web-us.didiglobal.com")
            // window.parent.postMessage({type:"resultRoleInfo",message:"close", page_type: data.page_type}, "https://pre-fleet-us.intra.didiglobal.com")
          }

          if (data.is_cycle && !this.isPreviewPage) {
            this.timeId = setTimeout(this.loop, 5 * 1000);
          }
        })
        .catch(err => {
          showAlertDialog(this);
        })
        .finally(() => {
          this.toast.hide();
          try {
            gtm({ event: "s8ObFinalVerify", Status: this.resultConfig.page_type});
            if(this.resultConfig.page_type.includes('success')) {
              snaptr('track', 'SIGN_UP', {eventID: Omega.getOmgid()});
              fbq('track', 'SubmitApplication', {eventID: Omega.getOmgid()});
            } else if (this.resultConfig.page_type.includes('checking')) {
              snaptr('track', 'SUBSCRIBE', {eventID: Omega.getOmgid()});
              fbq('track', 'Subscribe', {eventID: Omega.getOmgid()});
            }
          } catch (e) {}
        });
    },
    loop() {
      this.loopProcess();
    },
    loopProcess() {
      let up = new URLSearchParams(location.search);
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      post(process.env.GET_PROGRESS_URL, up)
        .then(data => {
          if (data.progress !== "resultInfo") {
            this.leave();
            this.$router.replace({ name: "home" });
          } else {
            this.loopPageConfig();
          }
        })
        .catch(err => console.log(err));
    },
    loopPageConfig() {
      let up = new URLSearchParams(location.search);
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      post(process.env.RESULT_URL, up)
        .then(data => {
          this.resultConfig = data;
          data.title && setTitle(data.title);

          this.timeId = setTimeout(this.loop, 5 * 1000);
        })
        .catch(err => console.log(err));
    },
    leave() {
      clearTimeout(this.timeId);
      // Fusion.resetBack &&
      //   Fusion.resetBack({
      //     reset: 2
      //   });
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeId);
    try {
      computeStayTime(this)
    } catch (error) {}
  },
  beforeCreate() {
    //一旦进入结果页，返回按钮需要正常返回
    Fusion.resetBack &&
      Fusion.resetBack({
        reset: 2
      });
  },
  mounted() {
    // this.getPageConfig();
    this.timeId=setTimeout(this.getPageConfig, 0);
    try {
      computeJumpTime(this)
    } catch (error) {}
  }
};
</script>
<style lang="scss" scoped>
#result-role {
  position: relative;
  height: 100%;
  padding: 0 0.4rem 0 0.4rem;
  box-sizing: border-box;
  user-select: text;
  background: #fff;

  .result-icon {
    display: block;
    width: 0.96rem;
    height: 0.96rem;
    margin: 0 auto 0.44rem;
    padding-top: 1.3rem;
    &.big-result-icon {
      max-height: 3.86rem;
      width: auto;
      height: auto;
      padding-top: 1.13rem;
    }
  }
  .result-icon + .content-wrap {
    padding-top: 0;
  }
  .content-wrap {
    padding-top: 0.6rem;
    &.content-wrap-center {
      text-align: center;
    }
  }
  .content-title {
    margin-bottom: 0.32rem;
    font-size: 0.48rem;
    color: #333333;
    font-weight: 700;
  }
  .content-desc {
    margin-bottom: 0.48rem;
    font-size: 0.32rem;
    line-height: 0.4rem;
    color: #999999;
    font-weight: 400;
  }
  .img-link {
    margin-top: 1.2rem;
  }
  .footer-wrap {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 0.32rem;
    box-sizing: border-box;
    box-shadow: 0 -20px 20px 0 rgba(0, 0, 0, 0.04);
    background: #fff;

    .footer-btn-wraper:not(.no-show){
      margin-bottom: 0.2rem;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  &.h5_funnel_fleet_pc {
    margin-top: 0;
    height: auto;
    width: 100%;
    padding: 0 80px;
    .result-icon {
      width: 48px;
      height: 48px;
      margin: 0 auto 24px;
      padding-top: 64px;
    }
    .content-title {
      margin-bottom: 12px;
      font-size: 24px;
    }
    .content-desc {
      margin-bottom: 12px;
      font-size: 16px;
    }
    .content-wrap {
      padding-bottom: 64px;
    }
    .footer-wrap {
      position: relative;
      box-shadow: none;
      padding: 0 0 64px 0;
      .footer-btn-wraper {
        ::v-deep .btn-wraper {
          height: 52px;
          line-height: 24px;
          border-radius: 10px;
          input {
            font-size: 20px!important;
            font-weight: 700;
          }
        }
      }
    }
  }
}
.result-role.h5_funnel_fleet {
  .footer-btn-wraper {
    ::v-deep .btn-wraper {
      border-radius: 0.2rem;
      input {
        font-size: 0.4rem!important;
        font-weight: 700;
      }
    }
  }
}
.result-role-wrapper {
  height: 100%;
  &.h5_funnel_fleet_pc {
    display: flex;
    align-items: center;
  }
}
</style>

